import React, { FC } from 'react';
import withStyles from 'src/common/withStyles';

import SignInLink from '../SignInLink';
import s from './EmailErrorMessage.module.scss';

type EmailErrorMessageProps = {
  errorMessage: string;
};

const EmailErrorMessage: FC<EmailErrorMessageProps> = ({ errorMessage }) => (
  <span>
    {errorMessage} <br />
    Would you like to <SignInLink /> instead?
  </span>
);

export default withStyles(s)(EmailErrorMessage);
